import useFormikDiscardFormState, {
  FormikDiscardFormStateOptions
} from "./useFormikDiscardFormState"

function SimpleFormikDiscardFormState(props: FormikDiscardFormStateOptions) {
  useFormikDiscardFormState(props)

  return null
}

export default SimpleFormikDiscardFormState
